export default __webpack_public_path__ + "static/media/5_5.8ea89b7f.png";